import { sanitizeString } from './sanitize';

const SECTION_SELECTOR = '[data-uplane-section], main section';
const KNOWN_SECTION_ROLE = /(?:^|-)(?:action|benefits|comparison|contact|cta|faq|features|hero|how-it-works|mechanism|pricing|product|proof|results|reviews|testimonials|trust)(?:-|$)/;

const slug = (value: string): string => sanitizeString(
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, ''),
  100
);

export const trackedSectionElements = (): Element[] => Array.from(
  document.querySelectorAll(SECTION_SELECTOR)
);

export const sectionTrackingName = (
  element: Element,
  trackedSections: readonly Element[] = trackedSectionElements()
): string | null => {
  const explicitName = slug(element.getAttribute('data-uplane-section') ?? '');
  if (explicitName) return explicitName;

  const id = slug(element.id);
  if (id) return id;

  const structuralClass = Array.from(element.classList)
    .map(slug)
    .find(className => KNOWN_SECTION_ROLE.test(className));
  if (structuralClass) return structuralClass;

  if (element.querySelector('h1')) return 'hero';
  const index = trackedSections.indexOf(element);
  return index >= 0 ? `section-${index + 1}` : null;
};

export const closestSectionTrackingName = (target: Element): string | null => {
  const section = target.closest(SECTION_SELECTOR);
  return section ? sectionTrackingName(section) : null;
};
